import { useCallback, useEffect, useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DYNAMIC_BAG_LABEL_TIMER } from '../../upsell.constants';

export const useDynamicBagButtonLabel = () => {
  const { formatMessage } = useIntl();

  // ─── Refs ──────────────────────────────────────────────────────────────────

  const labelTimeout = useRef<ReturnType<typeof setTimeout>>();

  // ───────────────────────────────────────────────────────────────────────────

  const [bagButtonLabel, setBagButtonLabel] = useState(
    formatMessage(messages.continueToBagHeader),
  );

  const updateBagButtonLabel = useCallback(() => {
    clearTimeout(labelTimeout.current);
    setBagButtonLabel(formatMessage(messages.addedToBagHeader));

    labelTimeout.current = setTimeout(() => {
      setBagButtonLabel(formatMessage(messages.continueToBagHeader));
    }, DYNAMIC_BAG_LABEL_TIMER);
  }, [formatMessage]);

  useEffect(() => {
    return () => {
      clearTimeout(labelTimeout.current);
    };
  }, [formatMessage]);

  return {
    bagButtonLabel,
    updateBagButtonLabel,
  };
};

// ─────────────────────────────────────────────────────────────────────────────

const messages = defineMessages({
  continueToBagHeader: {
    defaultMessage: 'Continue to bag',
    description: 'Upsell | Header | Continue to bag',
  },
  addedToBagHeader: {
    defaultMessage: 'Added to bag',
    description: 'Upsell | Header | Added to bag',
  },
});
